/**
 * WEBSOCKET / SIGNALR ADMIN SERVICE: CARRERA CONTINUA
 * Conexión en tiempo real del operador para recibir telemetría y eventos de Carrera Continua.
 */

import SignalRService from '../SignalRService';

let messageHandler = null;
let reconnectedHandler = null;

/**
 * Conecta el panel de administración al Hub de SignalR con el rol de operador de Carrera Continua.
 * @param {Function} onIncomingMessage - Callback para recibir mensajes y eventos emitidos por el Hub.
 * @param {Function} onStatusChange - Callback para notificar cambios de estado ('connecting', 'connected', 'error').
 * @param {string} roomId - Identificador único de la sala / partido.
 */
export const ConnectWebSocketForCarreraContinuaAdmin = (onIncomingMessage, onStatusChange = () => {}, roomId = '') => {
    onStatusChange('connecting');

    // Desuscribir handlers previos si existieran
    if (messageHandler) {
        SignalRService.off('message', messageHandler);
    }
    if (reconnectedHandler) {
        SignalRService.off('reconnected', reconnectedHandler);
    }

    messageHandler = (envelope) => {
        if (envelope && typeof onIncomingMessage === 'function') {
            onIncomingMessage(envelope);
        }
    };

    reconnectedHandler = () => {
        onStatusChange('connected');
    };

    SignalRService.on('message', messageHandler);
    SignalRService.on('reconnected', reconnectedHandler);

    SignalRService.connect({ tipo: 'carreracontinua:admin', roomId: roomId || '' })
        .then(() => {
            onStatusChange('connected');
        })
        .catch((err) => {
            console.error("[CarreraContinuaWS] Error al conectar a SignalR:", err);
            onStatusChange('error');
        });
};

/**
 * Desconecta limpiamente la sesión SignalR del operador.
 */
export const DisconnectWebSocketForCarreraContinuaAdmin = () => {
    try {
        if (messageHandler) {
            SignalRService.off('message', messageHandler);
            messageHandler = null;
        }
        if (reconnectedHandler) {
            SignalRService.off('reconnected', reconnectedHandler);
            reconnectedHandler = null;
        }
        SignalRService.disconnect();
    } catch (err) {
        console.error("[CarreraContinuaWS] Error al desconectar de SignalR:", err);
    }
};
